import { FieldTypes } from 'drapcode-constant';

export default async function (editor, opt = {}) {
  const traitManager = editor.TraitManager;
  let { collection } = opt.bindCollectionOptions;
  const traitOptions = collection
    ? collection.options
        .filter((field) => field.type === FieldTypes.url.id)
        .map((opt) => `<option value="${opt.id.split('"').join("'")}">${opt.name}</option>`)
        .join(',')
    : [];

  const dataCollectionFieldName = collection ? `data-video-src-${collection.collectionId}` : '';
  let componentContent = '';

  const style = document.createElement('style');
  style.innerHTML = `
        .checkmark::after {
            left: 4px;
            top: 4px;
        }
        checkbox{
        all:unset;
        }
       
        select option:first-child {
            color: grey;
        }
        select.empty {
            color: grey;
        }
        select option[disabled]:first-child {
            display: none;
        }
        input[type=webconnect-text] {
            display:block;
        }
        input[type=webconnect-link] {
          display:block;
      }
        
  `;
  document.head.appendChild(style);
  if (collection) {
    traitManager.addType(opt.traits.link.type, {
      createInput({ trait }) {
        componentContent = trait.attributes.content;
        const el = document.createElement('div');
        el.classList.add('custom-field');
        el.innerHTML = `    
                        <div id="URL">
                            <div class="form-group">
                                <label>
                                    <input type="checkbox" name="getSrcFrom" style="all: revert;"/>
                                        Get Video From ${collection.collectionTitle}
                                </label>
                            </div>
                            <div class="form-group">
                                <div id="select-field-div" style="display: none">
                                    <select class="selectField form-control form-control-sm options-light">
                   
                                    </select>
                                </div>
                            </div>
                        </div>
                        `;
        // const radioButton = el.querySelector("input[name=getTextFrom]");
        const checkbox = el.querySelector('input[type=checkbox][name="getSrcFrom"]');
        const selectFieldDiv = el.querySelector('#select-field-div');
        const selectField = el.querySelector('.selectField');
        checkbox.addEventListener('click', async (ev) => {
          console.log('ev,,,', ev);
          if (ev.target.checked) {
            selectField.innerHTML = '';
            let optionHtml = `<option value="" selected>- Select One -</option>`;
            optionHtml += traitOptions;
            selectField.innerHTML = optionHtml;
            selectFieldDiv.style.display = 'block';
          } else {
            selectFieldDiv.style.display = 'none';
          }
        });
        return el;
      },
      onEvent({ elInput, component }) {
        const select = elInput.querySelector('.selectField');
        const checkbox = elInput.querySelector('input[type=checkbox][name="getSrcFrom"]:checked');
        let selectFieldValue = select.value;
        if (selectFieldValue.includes("'")) {
          selectFieldValue = selectFieldValue.split("'").join('"');
        }
        console.log('selectFieldValue::', selectFieldValue, '--', checkbox);
        const attr = component.getAttributes();
        if (checkbox && selectFieldValue) {
          attr[dataCollectionFieldName] = selectFieldValue;
        } else {
          delete attr[dataCollectionFieldName];
        }
        component.setAttributes(attr);
        // component.set('content', '');
        // component.set('content', select.options[select.selectedIndex].text);
        console.log(component.getAttributes());
      },
      onUpdate({ elInput, component }) {
        const attr = component.getAttributes();
        let collectionFieldValue = attr[dataCollectionFieldName] || '';
        if (collectionFieldValue) {
          const select = elInput.querySelector('.selectField');
          const checkbox = elInput.querySelector('input[type=checkbox][name="getSrcFrom"]');
          checkbox.checked = true;
          const selectFieldDiv = elInput.querySelector('#select-field-div');
          select.innerHTML = '';
          let optionHtml = `<option value="" selected>- Select One -</option>`;
          optionHtml += traitOptions;
          select.innerHTML = optionHtml;
          if (collectionFieldValue.includes('"')) {
            collectionFieldValue = collectionFieldValue.split('"').join("'");
          }
          select.value = collectionFieldValue;
          selectFieldDiv.style.display = 'block';
        } else {
        }
      },
    });
  } else {
    traitManager.addType(opt.traits.link.type, {
      createInput({ trait }) {
        const el = document.createElement('div');
        el.innerHTML = ``;
        return el;
      },
    });
  }
}
